export default {
    // header
    headerImg: 'http://mk.chinaman.cn/mybigdatas/ids/static/logo001.png',
    headerTitle: 'MAIQS 2026',
    headerTitle1: '测量、人工智能、质量与可持续性国际会议',
    navList: [{
        text: "首页",
        url: "/",
    },
    {
        text: "组织者",
        url: "/organizing",
    },
    {
        text: "委员会",
        url: "/committee",
    },
    {
        text: "主题演讲",
        url: "/session",
    },
    {
        text: "项目",
        url: "/program",
    },
    {
        text: "提交",
        url: "/submissions",
    },
    {
        text: "注册",
        url: "/reg",
    },
    {
        text: "参会者信息",
        url: "sb",
        children: [{
            text: "签证",
            url: "/visa",
        },
        {
            text: "会场",
            url: "/travel",
        },
        {
            text: "旅行",
            url: "/traveltwo",
        },
        {
            text: "酒店",
            url: "/hotel",
        },
        ],
    },
    {
        text: "赞助商",
        url: "/sponsors",
    },
    {
        text: "奖项",
        url: "/awards",
    },
    ],
    // header
    // index
    indexTitle1: '会议信息',
    indexText1: `
        <p>国际测量、人工智能、质量与可持续性大会（MAIQS）是一个致力于推动这些相互关联领域的科学技术发展的顶级会议系列，旨在应对21世纪重要的工业和社会挑战。MAIQS 2026大会将汇集来自世界各地的顶尖学者、研究人员和行业专家，共同探讨和分享他们在测量、人工智能、质量和可持续性领域的最新见解和创新成果。我们携手合作，努力为全球工业和社会推动更智能、更可持续的解决方案，为所有人创造更美好的未来。</p>
        <p>诚邀有意向的作者向本次会议提交一篇全文（4-6页A4纸）。会议论文集将由EDP Sciences在MATEC Web of Conferences上发表。部分论文还有机会进行扩展并投稿至相关EI/SCI收录期刊。</p>`,
    indexTitle2: '重要日期',
    indexdateList: [{
        date: "2026年5月30日:",
        text: "全文提交截止",
    },
    {
        date: "2026年6月8日:",
        text: "论文录用通知",
    },
    {
        date: "2026年6月15日:",
        text: "论文最终提交截止日期"
    },
    {
        date: "2026年6月15日:",
        text: "早鸟注册",
    },
    {
        date: "2025年8月15日:",
        text: "最终注册"
    },
    ],
    indexTitle3: '相关新闻',
    indexText3: '第一轮会议通知',
    indexText4: '2026年MAIQS的议题包括',
    indexText5: [{
        title: "测量：",
        text: ""
    },
    {
        title: "数字校准、动态标准与可追溯性",
        text: ""
    },
    {
        title: "测量理论、误差与不确定性",
        text: ""
    },
    {
        title: "智能传感器与量子成像",
        text: ''
    },
    {
        title: "测量中的信号处理、数据分析和人工智能",
        text: ''
    },
    {
        title: "工业4.0、物联网和数字孪生的计量学",
        text: ''
    },
    {
        title: "测量系统的数字化转型",
        text: ''
    },
    {
        title: "人工智能",
        text: ''
    },
    {
        title: "机器学习与深度学习",
        text: ''
    },
    {
        title: "具身人工智能、机器人技术与自主系统、协作机器人、移动机器人、人形机器人",
        text: ''
    },
    {
        title: "自然语言处理（NLP）与大型语言模型（LLMs）",
        text: ''
    },
    {
        title: "可解释、合乎道德的人工智能与人工智能标准化",
        text: ''
    },
    {
        title: "人工智能助力智能、优质、可持续的系统",
        text: ''
    },
    {
        title: "高级机器智能（AMI）、通用人工智能（AGI）和未来人工智能方向",
        text: ''
    },
    {
        title: "质量：",
        text: ''
    },
    {
        title: "AI驱动的QFD、包容性设计以及TRIZ助力创新",
        text: ''
    },
    {
        title: "统计过程控制、六西格玛与精益4.0",
        text: ''
    },
    {
        title: "检验、测试、产品验证与合规性",
        text: ''
    },
    {
        title: "智能无损检测/无损评价、预测性维护和数字资产管理",
        text: ''
    },
    {
        title: "质量4.0、全面质量管理、卓越运营和社会责任",
        text: ''
    },
    {
        title: "可持续性：",
        text: ''
    },
    {
        title: "难以减排行业的深度脱碳技术",
        text: ''
    },
    {
        title: "人工智能赋能的能效4.0与行业耦合",
        text: ''
    },
    {
        title: "动态生命周期评价（LCA）、数字产品护照与范围3排放",
        text: ''
    },
    {
        title: "再生经济、城市矿产开采与关键原材料回收",
        text: ''
    },
    {
        title: "净零排放路径与环境、社会和治理（ESG）实施",
        text: ''
    },
    {
        title: "临界点、气候变化与可持续性",
        text: ''
    },
    {
        title: '跨学科：',
        text: ''
    },
    {
        title: "生成式人机交互、人机协作、空间计算与数字人类",
        text: ''
    },
    {
        title: "多模态基础模型与跨模态人工智能系统",
        text: ''
    },
    {
        title: "6G、工业互联网和时延敏感网络",
        text: ''
    },
    {
        title: "AI驱动的增材制造、工业元宇宙与智能工厂",
        text: ''
    },
    {
        title: "MAIQS助力可持续航空、航天系统及韧性供应链",
        text: ''
    },
    {
        title: "MAIQS在精准医疗、智慧农业和数字政府中的应用",
        text: ''
    },
    {
        title: "MAIQS助力自动驾驶交通、智能基础设施和零排放城市",
        text: ''
    }
    ],
    indexText6: "我的会议信息管理",
    indexText7: "邮件",
    indexText8: "密码",
    indexText9: "登录",
    indexText10: "创建账户",
    indexText11: "登录以进行:",
    indexText12: "摘要提交",
    indexText13: "全文稿件提交",
    indexText14: "在线注册",
    indexText15: "MAIQS 2026主题",
    indexText16: 'http://mk.chinaman.cn/mybigdatas/ids/static/logo003.png',
    indexText17: "已确认的主题演讲嘉宾",
    indexText18: [
        [{
            num: "002",
            title: "Arun S. Mujumdar 教授",
            text: "麦吉尔大学",
            tip: "加拿大",
        },
        {
            num: "001",
            title: "Alex Martynenko 教授",
            text: "达尔豪斯大学",
            tip: "加拿大",
        },
        {
            num: "018",
            title: "Azharul Karim 教授",
            text: "昆士兰科技大学",
            tip: "澳大利亚",
        },
        {
            num: "007",
            title: "Benu Adhikari 教授",
            text: "皇家墨尔本理工大学",
            tip: "澳大利亚",
        },
        {
            num: "003",
            title: "Bhesh Bhandari 教授",
            text: "昆士兰大学",
            tip: "澳大利亚",
        },
        ],
        [{
            num: "006",
            title: "Chung Lim Law 教授",
            text: "马来西亚诺丁汉大学",
            tip: "马来西亚",
        },

        {
            num: "026",
            title: "Dongxing Yu 高工/总经理",
            text: "尚好科技有限公司",
            tip: "中国",
        },
        {
            num: "012",
            title: "Duu-Jong Lee 教授",
            text: "香港城市大学",
            tip: "中国",
        },
        {
            num: "009",
            title: "Evangelos Tsotsas 教授",
            text: "马格德堡大学",
            tip: "德国",
        },
        {
            num: "022",
            title: "Gennadiy Semenov 教授",
            text: "俄罗斯生物技术大学",
            tip: "俄罗斯",
        },
        ],
        [{
            num: "011",
            title: "Hongwei Xiao 教授",
            text: "中国农业大学",
            tip: "中国",
        },
        {
            num: "013",
            title: "Ireneusz Zbiciński 教授",
            text: "罗兹理工大学",
            tip: "波兰",
        }, {
            num: "015",
            title: "Itaya Yoshinori 教授",
            text: "岐阜大学",
            tip: "日本",
        }, {
            num: "021",
            title: "Jamal Yagoobi 教授",
            text: "伍斯特理工学院",
            tip: "美国",
        },

        {
            num: "027",
            title: "Jing Wu 博士/高工/董事长",
            text: "山东天力能源股份有限公司",
            tip: "中国",
        },
        ],
        [{
            num: "014",
            title: "Patrick Perre 教授",
            text: "巴黎萨克雷大学",
            tip: "法国",
        },
        {
            num: "016",
            title: "Peng Xu 教授",
            text: "中国计量大学",
            tip: "中国",
        },
        {
            num: "004",
            title: "Sakamon Devahastin 教授",
            text: "国王科技大学",
            tip: "泰国",
        },
        {
            num: "023",
            title: "Shaojin Wang 教授",
            text: "西北农林科技大学",
            tip: "中国",
        },
        {
            num: "008",
            title: "Shusheng Pang 教授",
            text: "坎特伯雷大学",
            tip: "新西兰",
        },
        ],
        [{
            num: "010",
            title: "Song Miao 教授",
            text: "Teagasc国家食品研究中心",
            tip: "爱尔兰",
        }, {
            num: "019",
            title: "Vijaya Raghavan 教授",
            text: "麦吉尔大学",
            tip: "加拿大",
        },
        {
            num: "005",
            title: "Xiao Dong Chen 教授",
            text: "苏州大学",
            tip: "中国",
        },
        {
            num: "020",
            title: "Xu Duan 教授",
            text: "河南科技大学",
            tip: "中国",
        }, {
            num: '025',
            title: "Zhongli Pan 教授",
            text: "加利福尼亚大学戴维斯分校",
            tip: "美国"
        }
        ]
    ],
    indexText19: "联系我们",
    indexText20: "地址：",
    indexText21: "中国无锡江南大学食品学院",
    indexText22: "电子邮件：",
    indexText23: "contact@maiqs2026.org",
    indexText24: "网址：",
    indexText25: "https://maiqs2026.org",
    indexText26: "登录成功",
    indexText27: "",
    indexText28: "",
    indexText29: "",
    indexText30: "",

    indexmsgemail: "请输入你的邮箱",
    indexmsgpwd: "请输入你的密码",
    // index

    //footer 
    footReserved: '© MAIQS 2026 版权所有',
    footSymposium: 'MAIQS 2026 | 第23届国际干燥大会',
    footText1: "京ICP备20012029号-3",

    //organizing
    organizingTitle1: '承办单位: ',
    organizingTitle: '中国计量大学（CJLU）',
    organizingsmalltitle: '学校概况',
    organizingtext1: "中国计量大学（CJLU）是一所多学科大学，在计量、标准、质量、市场监管以及检验检疫方面具有显著优势。该校历史可追溯至1978年，当时由国家计量局创办为杭州计量学校。1985年，经教育部批准，该校升格为中国计量学院，2016年更名为中国计量大学。自2019年起，中国计量大学由浙江省人民政府和国家市场监管总局共同支持，并被认定为浙江省重点大学。2021年，中国计量大学获得国务院学位委员会授予的博士学位授予权，2023年，该校成功设立了仪器科学与技术以及光学工程两个博士后科研流动站。",
    organizingtext2: "浙江理工大学（CJLU）开设2个一级学科博士点、15个一级学科硕士学术学位点和15个专业硕士学位点。学校拥有9个浙江省一流学科，其中6个学科在全球ESI排名前1%。浙江理工大学拥有18个国家一流本科专业、4个国家特色专业、1个国家综合改革试点专业、4个长江三角洲新文科认证专业和9个国家工程教育认证专业。此外，学校还拥有24个省级一流本科专业、7个省级优势专业、12个省级特色专业和5个教育部“卓越工程师教育培养计划”专业。浙江理工大学还开设14门国家一流课程，以及7门国家级精品课程、资源共享课程和双语教学示范课程。学校拥有151门省级一流课程和22门省级精品课程。学校设有1个国家级实验教学示范中心、1个国家级虚拟仿真实验教学中心和14个省级实验教学示范中心。浙江理工大学还设有1个国家级人才培养模式创新实验区、1个国家级工程硕士专业学位联合培养示范基地，以及15个省级联合培养基地。",
    organizingtext3: '建有食品科学与技术国家重点实验室、粮食发酵与食品生物制造国家工程研究中心、国家功能食品工程技术研究中心等国家级科研平台8个。学校坚持师生为重、服务为先，倾力打造曲水流 觞的现代化生态校园，为学生提供设施先进、功能齐全、优质舒适的成长环境。学校现启用蠡湖校区、东氿校区，总占地面积3786亩，总建筑面积119.87万平方米。',
    organizingtext4: '江南开学府，万顷湖波扬;屏障九龙好，山高水又长。”未来的办学实践中，我们将继续秉承“质量立校、人才强校、服务兴校、机制活校、文化铸校”的发展方略，努力推进“世界知名、中国一流、江南风格的研究型大学”建设，为实现高等教育强国梦和中华民族伟大复兴作出新的更大的贡献!',
    organizingsmalltitle2: '排名',
    organizingtext5: '学校的综合实力和办学影响不断提升。在教育部组织的最新一轮全国一级学科评估中，取得优异成绩;在2022年“软科世界一流学科排名”中，学校15个学科入选，食品科学与工程学科连续 四年蝉联世界第一;在全球基本科学指标数据库(ESI)上，学校农业科学、工程学、化学、生物学与生物化学材料科学、临床医学、计算机科学、药理学与毒理学、环境与生态学、微生物学10 个学科进入全球前 1%，其中农业科学跻身前0.12‰;学校位居ESI综合排行中国大陆第56名;在中国管理科学研究院编制的《2023中国大学评价》中，位居全国第49名。学校是全国教育系统先 进集体、江苏省文明单位、江苏省平安校园。',
    organizingaddresss: '地址',
    organizingaddressstext: '江苏省无锡市蠡湖大道1800号',
    organizingdetails: '详情请见:',
    organizingtext10: "邮编",
    organizingtext11: "214122",
    organizingtext12: "https://www.cjlu.edu.cn/index.htm",

    //Co-organizers
    coOrganizersBigTitle: '协办单位:',
    coOrganizersAboutTitle: '(正在建设中)',
    coOrganizersTitle: '1. 中国通用机械工业协会干燥设备分会',
    coOrganizersText1: '中国通用机械工业协会干燥设备分会是隶属于中国通用机械工业协会的分支机构，是中国通用机械工业协会十二家专业分会之一，于1993年成立。',
    coOrganizersText2: "中国通用机械工业协会干燥设备分会是依法成立，经中华人民共和国民政部批准登记，由国内外干燥设备企业、科研院所、高等院校等单位自愿组成的非赢利性、全国性的社会团体。",
    coOrganizersText3: "中国通用机械工业协会干燥设备分会以推动中国干燥设备企业发展为宗旨，以提升产业素质为己任，为政府、行业、社会提供与行业相关的各种服务，致力于产业结构调整和增长模式创新，在加大国产化干燥设备的品牌培育、扶植和提高基础上，着力与上下游行业以及企业与政府间的沟通协调，并加快国际合作步伐，努力为中国干燥设备企业发展营造良好的氛围。",
    coOrganizersText4: "北京市西城区车公庄大街9号院五栋大楼B座2单元5层",
    coOrganizersText5: " https://dr.cgmia.org.cn/About/AboutOne/11",


    coOrganizersTitleA1: '国际干燥科学与技术研究会（澳门）',
    coOrganizersTextA1: '国际干燥科学与技术研究会（澳门）（International Research Association for Drying Science &Technology (Macao)，简称 IRADSTM）于2024年 6月在澳门成功注册，成为目前唯一正 式注册的国际干燥专业学术团体。IRADSTM是由全球干燥领域相关学科专家自愿组建的专 业性、学术性、非营利性的社会组织，其宗旨是促进干燥高效节能与绿色发展，促进干燥科 学的普及与先进技术的推广应用，促进干燥科技人才的培养，推动国际干燥科技事业健康、 稳定、可持续地发展。',


    coOrganizersTitleA2: '中国通用机械工业协会干燥设备分会',
    coOrganizersTextA21: '中国通用机械工业协会干燥设备分会是隶属于中国通用机械工业协会的分支机构，是中国通用机械工业协会十二家专业分会之一，于1993年成立。',
    coOrganizersTextA22: '中国通用机械工业协会干燥设备分会是依法成立，经中华人民共和国民政部批准登记，由国内外干燥设备企业、科研院所、高等院校等单位自愿组成的非赢利性、全国性的社会团体。',
    coOrganizersTextA23: '中国通用机械工业协会干燥设备分会以推动中国干燥设备企业发展为宗旨，以提升产业素质为己任，为政府、行业、社会提供与行业相关的各种服务，致力于产业结构调整和增长模式创新，在加大国产化干燥设备的品牌培育、扶植和提高基础上，着力与上下游行业以及企业与政府间的沟通协调，并加快国际合作步伐，努力为中国干燥设备企业发展营造良好的氛围。',
    coOrganizersTextAB21: "北京市西城区车公庄大街9号院五栋大楼B座2单元5层",
    coOrganizersTextAB22: " https://dr.cgmia.org.cn/About/AboutOne/11",


    coOrganizersTitleA3: '中国计量大学',
    coOrganizersTextA31: '中国计量大学是一所以计量、标准、质量、市场监管和检验检疫为办学特色的高等院校，学校前身是1978年由国家计量总局创建的杭州计量学校。学校设有博士学位授权一级学科点2个，硕士学位授权一级学科点15个、硕士专业学位授权点11个。浙江省一流学科9个，ESI全球排名前1%学科4个。国家级一流专业18个，国家特色专业4个，国家级专业综合改革试点专业1个，全国工程教育认证专业9个。学校设有19个学院（部、中心），现有全日制在校普通本科生1.8万余人，研究生近5000人，留学生400余人。学校现有专任教师近1500人，其中国家级领军人才20余人次，省部级人才80余人次。学校现有省部级以上科研平台40余个，高水平研究院35个，获国家科学技术二等奖3项、省部级奖励百余项。',
    coOrganizersTextA32: '中国计量大学能源环境与安全工程学院（碳计量学院）于2024年1月组建成立，拥有安全科学与工程、动力工程及工程热物理、环境科学与工程3个一级学科，其中安全科学与工程是浙江省重点学科和浙江省一流学科。学院设有安全科学与工程、能源动力类、资源与环境类硕士学位授权点，在读研究生300余名。学院建有安全工程、能源与动力工程、环境工程等3个本科专业，在校生800余人，安全工程专业、能源与动力工程专业是国家级一流本科专业。学院现有专任教师94人，其中国家顶尖人才2人、享受国务院政府特殊津贴人员2人。学院建有浙江省特种设备与能源环保计量技术服务创新平台、河南省碳测量技术与高端仪器装置工程研究中心等7个省部级科研教学实验平台。学院坚持"依托市场监管行业，培养高端人才，服务地方建设"的理念，主动对接国家、区域经济社会发展的重大需求和战略新兴产业，目前已和安科院、特检院、省应急厅、省应科院、省特检院、省质科院、浙能集团、白马湖实验室、杭州热电等多家单位展开合作，在特种设备安全检测技术、能源清洁燃烧技术、碳计量、环境健康等方面取得较突出的成绩，得到了学界与行业认同。',
    coOrganizersTextAB31: "浙江省杭州市钱塘区学源街258号",
    coOrganizersTextAB32: " https://www.cjlu.edu.cn/",


    coOrganizersTitleA4: '中国农业大学',
    coOrganizersTextA41: '中国农业大学始于1905年成立的京师大学堂农科大学，是我国现代农业高等教育的起源地，是教育部直属的双一流大学，是“985工程”和“211工程”重点建设的高水平研究型大学。现任党委书记是钟登华院士，校长是孙其信院士。中国农业大学因农而生，也因农而兴，优于农，但不囿于农。历经百年的世纪风雨，中国农业大学已经发展成为一所以农学、生命科学、农业工程和食品科学为特色和优势的研究型大学。现有中国科学院院士4人，中国工程院院士11人，拥有长江学者特聘教授、杰出青年基金获得者、国家万人计划领军人才等各类国家级人才近300人次；在教育部第四轮一级学科评估中，农业工程、食品科学与工程、作物学、畜牧学、兽医学、草学等6个学科被评为A+学科，A+学科数量位居全国高校第6位；学校现有17个国家级科研平台，包括9个全国重点实验室，1个国家工程实验室，2个国家工程技术研究中心，1个国家级研发中心，1个国家级国际联合研究中心，3个国家野外科学观测研究站；129个省部级科研平台，国家重点实验室数量位居全国高效第4位。 中国农业大学基础研究实力雄厚，在国际著名杂志《SCIENCE》、《CELL》、《NATURE》和《NATURE GENETICS》上发表34篇高水平研究论文；有15个学科进入ESI全球前1%，植物与动物科学、环境、生态学等三个学科进入全球前千分之一，农业科学稳居全球前万分之一。',
    coOrganizersTextA42: '在农产品干燥方面，中国农业大学具有悠久的历史，是中国农产品干燥研究的起源地和国际干燥研究的重镇。上世纪50年代初曹崇文先生就从事农业机械和农产品干燥方面的教学和科研工作，毕生致力于农产品干燥加工和农业机械方面的研究，是我国农产品干燥研究的奠基人和开拓者之一，是中国农业大学农产品加工博士授予点的创始人，是首届全国百篇优秀博士论文获得者指导教师，第13届国际干燥大会主席（IDS-2002），主编了领域工具书《现代干燥技术》（第1版），是第一位获得干燥领域最高奖Mujumdar奖章的中国学者。山河日月镌刻璀璨初心，七十载春秋写就举世华章。一代代中农干燥人披星戴月、风雨兼程，扎根中国大地，深入产业一线，为干燥领域培养和输送了400多位硕士、博士研究生和博士后，为中国和世界的干燥技术研究和产业发展做出了不可磨灭的贡献。',
    coOrganizersTextAB41: "北京市海淀区清华东路17号（东校区）",
    coOrganizersTextAB42: " https://www.cau.edu.cn/",

    coOrganizersTitleA5: '北京交通大学',
    coOrganizersTextA51: '北京交通大学是教育部直属，教育部、交通运输部、北京市人民政府和中国国家铁路集团有限公司共建的全国重点大学，是国家“211工程”“985工程优势学科创新平台”“双一流”建设高校。北京交通大学作为交通大学的三个源头之一，历史渊源可追溯到1896年，是中国近代铁路管理、电信教育的发祥地。历经双甲子发展，学校设有20个学院，15个学科入围软科世界一流学科排名，交通运输工程学科5次排名世界第一；15个学科入围U.S.News世界大学学科排名；7个学科进入QS世界顶尖学科排名；23个学科入围软科中国最好学科排名，交通运输工程、系统科学继续蝉联全国第一；8个学科进入ESI前1%，工程学保持ESI前1‰。学校建有博士后科研流动站17个，工作站1个；有一级学科博士点21个，一级学科硕士点32个。学校有中国科学院院士3人，中国工程院院士8人，中国工程院外籍院士1人，国家级教学名师5人，国务院学位委员会学科评议组成员6人，各类国家人才计划入选教师76人，中宣部“四个一批”人才2人，学校在校生约3万人，省部级以上科研平台75个。学校积极响应国家“一带一路”倡议，与美、英、德、法等51个国家的252所大学和机构建立了合作关系，与交通、信息、能源行业企业，科技创新型企业等近400家企业建立战略合作关系，董事单位达88家；海内外校友组织61家；教育基金会成为民政部认定4A级慈善组织。北京交通大学机械与电子控制工程学院成立于2000年，源于1958年成立的铁道机械系。学院现有教职工230余人，其中中国工程院双聘院士2人、国家百千万人才工程1人、国家万人计划1人、中央军委人才计划1人、国家级创新团队1个、教育部创新团队1个、北京市优秀教学团队1个、IEEE Fellow１人、交通运输青年科技英才2人、北京市高等学校教学名师5人。学院下设机械工程、车辆工程、测控技术与仪器、能源与动力工程、工业工程和机械电子工程（中外合作办学）6个本科专业，全部获批国家级一流专业建设点，其中国家级特色专业1个，4个专业通过国家工程教育专业认证。学院拥有机械工程国家级实验教学示范中心、国家级工程实践教育中心、国家级虚拟仿真教学项目、全国工程专业学位研究生培养示范基地等多个国家级教学实践平台。目前学院拥有2个博士后流动站、1个一级学科博士学位授权点、2个专业学位博士授权点、8个学术型硕士学位授权点、4个专业学位硕士授权点。第四轮学科评估中，机械工程学科评估结果为B+、连续入围U.S.News世界大学顶尖学科排行榜。载运工具运用工程所在的交通运输工程学科连续4年蝉联软科世界一流学科排名第一。动力工程及热物理、材料科学与工程学科在国内国际学科评价中均位居前列。',
    coOrganizersTextA52: '',
    coOrganizersTextAB51: "北京市海淀区上园村3号北京交通大学",
    coOrganizersTextAB52: "https://www.bjtu.edu.cn/",


    coOrganizersTitleA6: '中国农业科学院农产品加工研究所',
    coOrganizersTextA61: "中国农业科学院农产品加工研究所（简称“加工所”），是国家级农产品加工科研机构，前身为中国农业科学院原子能利用研究所。2002年10月，经农业部、科技部、中编办批复，调整为农产品加工研究所，2003年12月挂牌。加工所致力于解决全国农产品加工基础性、方向性、全局性、关键性重大科技问题，重点推动大宗农产品减损保供、特色农产品提质增效、“大食物观”食物安全研究和产业发展战略研究，在保障粮食安全与重要农产品稳定安全供给，全面支撑实施乡村振兴、健康中国和制造强国战略等方面行使国家队职责。加工所构建了“一体、两翼、三拓展”学科体系，即夯实农产品加工与贮藏学科主体，强化质量安全、营养健康两翼重点学科方向，拓展合成生物学、智能感官和数字加工三个新兴交叉学科方向。组建“9+6”院所两级创新团队，即谷物加工与品质调控、植物蛋白结构与功能调控、肉品科学与营养工程、果蔬加工与品质调控、薯类食品科学与技术、中式食品加工与装备、食物营养与功能性食品、食品生物制造、粮油减损与真菌毒素防控9个院级创新团队，植物化学组分与组学研究、农产品加工质量安全防控、农产品保鲜与物流、乳品加工与品质调控、马铃薯加工与品质调控、乡村产业振兴研究6个所级培育创新团队。建有农业农村部农产品加工综合性重点实验室等11个部级平台，承担国家农产品加工技术研发体系、国家农产品加工标准化技术委员会运行工作，是国家农产品加工产业科技创新联盟等8个联盟、学会、协会的理事长（主任委员）单位。建有中国-阿根廷食品科学技术中心等24个双多边国际合作实验室与平台，是国家引才引智示范基地。建有食品科学与工程、农产品加工利用、农产品质量与食物安全、生物化学与分子生物学4个博士点，食品科学、农产品加工及贮藏工程、粮食油脂及植物蛋白工程、生物化学与分子生物学、食品加工与安全（专业学位）、生物与医药（专业学位）、农业经济管理、农业管理（专业学位）等8个硕士点，在读研究生510人。至2024年8月30日，所内拥有在编职工192人、聘用制职工80人、在站博士后21人、退休职工139人。职工平均年龄38.1岁，40岁以下职工人数占比69 %。全所正高级职称36人、副高级职称58人，国际食品科学院院士1人，国家级人才14人次，中国农业科学院“农科英才”10人。",
    coOrganizersTextAB61: "北京市海淀区圆明园西路2号中国农业科学院农产品加工研究所",
    coOrganizersTextAB62: "https://ifst.caas.cn/",


    coOrganizersTitleA7: '江苏省农业科学院',
    coOrganizersTextA71: "江苏省农业科学院是直属于江苏省人民政府的综合性公益一类农业科研机构，前身为1931年原国民政府创立的中央农业试验所，历经华东农科所、中国农科院江苏分院、江苏省农科所等历史时期，是我国近代农业科技组织化、建制化发展的开创者和奠基者之一。全院有16个专业所，11个农区所，2个科学试验站，97个部省级以上科技创新平台，在南京溧水、六合分别建有1218亩植物科学基地和3316亩动物科学基地，在盐城建有8860亩沿海现代农业科技创新与示范基地。江苏省农业科学院学科齐全，特色鲜明，农业科学、植物与动物科学进入ESI全球排名前1%，现有院士1名、国家“百千万人才工程”专家5名、国家级重点人才4名、省级以上突出贡献专家72名，享受国务院特殊津贴56人，入选国家现代农业产业技术体系56人；与FAO等国际组织签署全面战略合作协议，与120家海外高水平大学、科研机构和“一带一路”国家高效院所建立合作关系。",
    coOrganizersTextA72: "农产品加工研究所果蔬加工创新团队成立于2005年，现有科技人员15人，其中省“333高层次人才培养工程”二层次对象1人，省级有突出贡献中青年专家1人，长期从事果蔬精深加工品质调控、果蔬活性物质营养提升与健康制造、果蔬功能因子和生物合成定向调控相关研究；承担各类科研项目90余项，其中国家重点研发计划、国家自然科学基金、省自然科学基金等部省级以上项目70多项，发表论文370多篇，获授权国家发明专利60 余项，江苏省科学技术二等奖、中国食品工业协会特等奖、中国商业联合会科学技术一等奖等24项，制定省级以上标准29项、团体及企业标准58项，主导技术在三只松鼠、艾兰得、嘉安食品、康能生物、联富食品、银杏源科技等企业产业化推广。",
    coOrganizersTextAB71: "江苏省南京市钟灵街50号",
    coOrganizersTextAB72: "https://www.jaas.ac.cn/",


    coOrganizersTitleA8: '陕西科技大学',
    coOrganizersTextA81: "陕西科技大学是国家“中西部高校基础能力建设工程”及“十四五教育强国推进工程”建设高校，是陕西省国家“双一流”培育高校和重点建设的高水平大学。作为最早的轻工高等学校，创建于1958年，1970年迁至陕西咸阳，2006年迁至陕西西安。学校作为“西迁群体”之一，经过六十多年的发展，历经“三创两迁”的奋斗，培养了18万余名优秀人才。在2024软科中国大学排名中居全国第124位。学校设有16个学院，5个学科位列ESI全球排名前1%，软科世界一流学科10个，国家级一流本科专业21个，国家级特色专业9个，中国工程教育认证专业19个。建有博士后科研流动站4个；有博士一级授权学科及博士专业学位授权点11个；有硕士学位授权一级学科22个，硕士专业学位授权点16个；本科专业70个。拥有“长江学者”、“杰青”、“优青”、“国家高层次人才特殊支持计划”、“百千万人才工程”等国家、省级各类人才百余人；有国家级、省部级重点实验室、重点研究基地和工程技术研究中心等84个，省级研究生联合培养示范工作站6个，院士创新团队9个。“十三五”以来，共承担各类纵向科研项目3031项，获得省部级以上科技成果奖励164项，出版著作141部，SCI二区以上收录论文3065篇，授权国内发明专利3875件，国外专利103件。通过“一院一策”先后与美国、加拿大、德国、英国、澳大利亚、新西兰、哈萨克斯坦、香港、台湾等20多个国家和地区的50余所高校和科研机构建立了密切的合作关系。陕西科技大学机电工程学院现有教工160余人，其中高级职称74人，博、硕士生导师75人，拥有陕西省人才和荣誉称号近30人；陕西科技创新团队1个，陕西高校青年创新团队2个；陕西省教学团队6个；有国家一流专业1个，国家特色专业1个，陕西省一流专业3个，国际工程教育认证专业3个；拥有1个一级学科博士学位授权点，2个一级学科硕士学位授权点，其中动力工程及工程热物理学科是我校多年来重点培育的交叉学科之一，下设化工过程机械、热能工程和新能源科学与工程3个培养方向，建有“干燥及节能技术”、“真空技术”和“新能源利用技术”等研究平台，主要面向轻工装备、农产品深加工、新能源等国家和地区需求，在轻化工过程装备、干燥技术及装备、生物质能源利用等方面形成了多学科交叉、特色鲜明的研究方向。",
    coOrganizersTextA82: " ",
    coOrganizersTextAB81: "陕西省西安市未央大学园区",
    coOrganizersTextAB82: "https://www.sust.edu.cn/",

    coOrganizersTitleA9: '苏州大学',
    coOrganizersTextA91: "苏州大学是国家“211工程”“2011计划”首批入列高校，教育部与江苏省人民政府共建“双一流”建设高校、国家航天局共建高校，江苏省属重点综合性大学。苏州大学现设有37个学院（部），132个本科专业，47个一级学科硕士点，35个专业学位硕士点，31个一级学科博士点，1个专业学位博士点，30个博士后流动站，1个国家一流学科，4个国家重点学科。目前化学、材料科学和工程学等5个学科进入全球基本科学指标（ESI）前1‰。学校按照“以国际知名带动国内一流”的发展思路，全面深入推进教育国际化进程，先后与30多个国家的200余所高校和研究机构建立了校际交流关系，拥有来自全球的来华留学生千余人。苏州大学材料与化学化工学部前身是东吴大学化学系，创建于1914年。1917年，两名研究生获得化学硕士学位，是东吴大学授予的第一批硕士学位，也是迄今为止能够确定的中国第一批化学硕士。2024年，苏州大学化学化工学科迎来创立110周年华诞。学部涵盖化学、材料科学与工程、化学工程与技术3个一级学科，拥有3个一级学科博士点授予权和博士后流动站。材料科学与工程为“一流学科”，化学、化学工程与技术是江苏高校优势学科建设项目。2024软科中国最好学科排名中，化学排名19、材料科学与工程排名19、化学工程与技术排名14，全部进入国内前12%。化学、高分子材料与工程、化学工程与工艺专业为国家级一流本科专业建设点和江苏省品牌专业，化学工程与工艺专业获批江苏省卓越工程师教育培养计划2.0专业建设点。学部科研条件优越，拥有新型功能高分子材料国家地方联合工程实验室、环保功能吸附材料制备技术国家地方联合工程实验室等2个国家级科研平台，以及10余个省级实验室以及其他20余个市、校级重点实验室。取得多项具有国际先进水平的科技成果，先后获得国家技术发明奖二等奖2项、国家科学技术进步奖二等奖1项、何梁何利基金科学与技术创新奖、全国创新争先奖、中国专利优秀奖及其他省部级科技奖励20余项。在Science、Nature、Nat. Chem.、Nat. Mater.、Nat. Energy、Nat. Electron.、J. Am. Chem. Soc.、Angew. Chem. Int. Ed.、Adv. Mater.、AIChE J.等国际高水平学术期刊发表论文，近三年发表100余篇。苏州大学材料与化学化工学部座落于美丽宁静的苏州工业园区独墅湖高等教育区，是读书和研究的理想之地。学部全体师生热忱欢迎有志于在化学化工与材料等领域有所作为的莘莘学子进入学部深造，同时也热切期盼海内外化学化工与材料等学科的优秀学者加盟。",
    coOrganizersTextA92: " ",
    coOrganizersTextAB91: "江苏省苏州市姑苏区十梓街1号",
    coOrganizersTextAB92: "https://www.suda.edu.cn/",


    coOrganizersTitleA10: '贺州学院',
    coOrganizersTextA101: "贺州学院食品与生物工程学院前身是梧州地区八步师范学校化学教学科，1977年开始招收3年制大专，2006年开始招收本科生，2012年成立化学与生物工程学院，2015年成立食品科学与工程技术研究院，2016年12月由原化学与生物工程学院部分专业析出后更名为食品与生物工程学院并与食品科学与工程技术研究院合并至今。学院现有食品科学与工程、食品质量与安全、生物工程、茶学4个本科专业。其中，食品科学与工程专业2012年获批自治区特色专业，2018年入选广西一流学科（培育）建设并在2019年顺利通过中期绩效评估，2019年入选广西一流专业建设点，2021年入选教育部“双万计划”2020年度国家级一流本科专业建设点，2022年入选广西新一轮一流学科（B类）。食品质量与安全专业2022年入选2021年度省级一流本科专业建设点。生物工程专业是学院办学历史最早的专业。茶学专业依托地方特色资源开设，为广西高校最早招收的茶学本科专业。《果蔬贮藏保鲜》与《食品添加剂》被认定为2020年自治区级一流本科课程。《食品化学》被认定为2023年普通本科高校自治区级课程思政示范课程。学院拥有一支科研能力强，教学水平高，学历、职称和年龄结构合理的教师队伍。现有专任教师82人，其中正高职称11人，副高职称27 人，硕士以上80人，双师型教师22人，有1年以上出国（境）留学经历的教师14人；校外兼职博导3人，硕导11人。外聘中国工程院院士1人，享受国务院政府特殊津贴1人，教育部高等学校食品科学与工程类专业教学指导委员会委员1人，2019-2022年广西本科高等学校教学指导委员会委员6人（其中食品科学与工程类主任委员1人，秘书长1人，委员2人；生物科学与生物工程类教学指导委员会委员1人；农林类教学指导委员会委员1人），广西特聘专家1人，二级教授1人，广西高层次人才D层次1人，广西优秀卓越学者1人，贺江学者1人。2015年广西果蔬保鲜和深加工研究人才小高地获批自治区第六批人才小高地，并在2019年工作考核中被评为优秀。2018年供港澳蔬菜质量安全控制研究创新团队入选广西高水平创新团队。学院以高素质应用型人才培养为目标，以工程教育认证为标准，不断完善学院教学条件和教学管理水平。学院现有教学科研用房7080平方米，仪器设备总值4000万元以上，设有食品精深加工、产品风味调控、农产品副产物综合利用、果蔬活性成分开发与利用等专业实验室，还建设有中试基地、中试生产线等一系列配套完整的校内理论、实践教学场地和设施体系，以及多个校外实践教学基地，能够充分满足各专业各教学环节教学需要。近五年，学院教师承担各类科研项目100余项，其中国家级项目立项16项，省级科研项目立项48项，市厅级科研项目立项18项，纵向科研经费2000余万元；服务地方横向科研项目近100项，到账经费近700万元。获广西自然科学二等奖1项，广西科技进步三等奖1项。学科和平台建设经费5500万元以上。发表论文317篇，其中SCI论文75篇，核心论文120篇。申请专利151项，制定广西地方标准4项，并已发布实施。学院积极服务地方产业，与正大集团（广西）、广西贺州农贝贝农牧科技有限公司、广西壮族自治区国有大桂山林场、广西将军峰茶业集团有限公司等多家企业通过技术转移、建立科研实践基地等方式建立长期合作关系，为企业提供先进的加工理论和关键技术，提高了企业的经济效益。2015年开始与大连工业大学联合培养研究生，2019年开始与乌克兰苏梅国立农业大学联合培养研究生，2020年开始与广西科技大学联合培养研究生，累计联合培养研究生77人。学院积极开展对外交流合作，2016年主办全国马蹄深加工与保鲜技术研讨会，2017年主办首届莲藕及水生植物产业发展大会，2018年参与协办第六届中国休闲食品产业发展大会和第二届食品营养与健康国际研讨会，参与承办第五届食品干燥国际研讨会和2019年国际食品非热加工技术研讨会，2020年联合主办第四届“生鲜食品加工与保鲜”国际学术研讨会，2021年联合主办“第三届食品科学与营养健康国际研讨会”，2023年联合承办教育部高等学校食品科学与工程类专业教学指导委员会和第六届“生鲜食品加工与保鲜”国际学术研讨会，联合主办“第四届食品科学与营养健康国际研讨会”。 ",
    coOrganizersTextA102: " ",
    coOrganizersTextAB101: "广西贺州市八步区潇贺大道3261号",
    coOrganizersTextAB102: "https://www.hzxy.edu.cn/",


    coOrganizersTitleA11: '浙江科技大学',
    coOrganizersTextA111: "学校前身由浙江大学和杭州市于1980年创办。2022年成为浙江省博士学位授予立项建设单位。2023年更名为浙江科技大学。经过40多年的建设，学校已发展成为一所国际化办学和区域特色鲜明的一流应用型省属本科高校。学校现有杭州小和山、湖州安吉两个校区，占地面积2900余亩。设有17个二级学院和1个教学部；现有56个本科专业，6个学术型硕士学位授权一级学科，8个硕士专业学位授权点；有全日制本科生、研究生19000余名，来华留学生1400余名。学校拥有一支具有国际化视野、学术水平高、师德师风高尚、梯队结构合理的优秀人才队伍。现有在编教职工1700余名，专任教师1360余名，其中高级职称教师近550名，具有博士学位教师占61%。拥有浙江省特级专家、国家高层次人才特殊支持计划、“长江学者和创新团队发展计划”创新团队带头人、国家百千万人才工程、国家有突出贡献的中青年专家等顶尖和国家级人才近30人次，省部级人才近120人次。 ",
    coOrganizersTextA112: "食品科学与工程学科与省内高校差异化发展，重点服务地方“落地”，是我校典型的应用型学科之一，先后被评为校“十三五”期间优势特色建设专业和浙江省一流专业，2022年通过了中国工程教育认证，与娃哈哈、贝因美、熊猫乳品、海通集团、王龙集团等知名企业建立了长期合作关系，社会服务成效显著。成为了浙江省食品学会副理事长单位、浙江省食品添加剂专家委员会主任委员单位、浙江省乳制品分会专家委员会主任委员单位等，在食品添加剂和乳制品加工领域特色显著。",
    coOrganizersTextAB111: "浙江省杭州市西湖区留和路318号",
    coOrganizersTextAB112: "https://www.zust.edu.cn/index.htm",

    coOrganizersTitleA12: '广东省农业科学院蚕业与农产品加工研究所',
    coOrganizersTextA121: "广东省农业科学院蚕业与农产品加工研究所，成立于 1952 年，省属公益二类科研事业单位，主要从事农产品加工和蚕桑科技两大领域的科研与推广工作，研究领域覆盖果蔬、粮油、畜禽、水产、保鲜、功能食品及蚕桑等产业。研究所围绕产业链布局创新链，搭建了“基础研究—核心技术—工程化应用”上下游一体化全链条创新平台体系，建有农产品加工省部共建国家重点实验室培育基地、农业农村部功能食品重点实验室，广东省农产品加工重点实验室、热带亚热带果蔬加工技术国家地方联合工程研究中心、广东省农产品加工技术中试公共服务、广东省预制菜产业联合研究院、广东省农产品加工服务产业园等国家和省部级科研平台28个，仪器和设备总值过亿元。研究所坚持党建科研两手抓，先后培养了国务院政府特殊津贴专家6人，全国先进工作者（劳动模范）2人，中国工程院院士有效候选人1名，国家“万人计划”科技创新领军人才2人，神农领军人才2人和青年英才2人等一批高层次人才。近年来先后获国家科技进步二等奖3项、省部级科技一等奖15项；2005年获省文明单位且一直保留至今，2024 年获广东省五一劳动奖状。",
    coOrganizersTextA122: "研究所与省内外300多家企业对接合作，与格力、海天、完美等50多家知名企业共建研究院或研发中心，成功孵育了“宝桑园”和“力衡”两个高新技术品牌。“十三五”以来，转化服务600多项，科技支撑7个国家级、77个省级现代农业产业园。积极参与东西部协作、援疆、援藏与省驻镇帮扶等工作，研发的成果和技术推广到全国近20个省、自治区，为百千万工程和乡村振兴提供科技支撑。",
    coOrganizersTextAB121: "广东省广州市天河区东莞庄一横路133号",
    coOrganizersTextAB122: "http://www.gdaas.cn/srigaas/",


    //committee
    committeebigtitle: 'MAIQS 2026 委员会',
    committeeOrganizing: '组委会',
    committeeScientific: '科学委员会(IDS国际顾问团)',
    committeeheaderImg: 'http://mk.chinaman.cn/mybigdatas/ids/static/commit2.png',
    committeepeopleList: [{
        name: "张慜",
        text: "江南大学，中国无锡 (MAIQS 2026主席)",
    },
    {
        name: "毕金峰",
        text: "中国农业科学院农产品加工研究所，中国北京",
    },
    {
        name: "陈晓东",
        text: "苏州大学，中国苏州",
    },
    {
        name: "段续",
        text: "河南科技大学，中国洛阳",
    },
    {
        name: "金敬红",
        text: "南京野生植物综合利用研究所，中国南京",
    },
    {
        name: "李大婧",
        text: "江苏省农业科学院农产品加工研究所，中国南京",
    },
    {
        name: "李所彬",
        text: "江苏博莱客冷冻科技发展有限公司，中国常州",
    },
    {
        name: "李占勇",
        text: "天津科技大学，中国天津",
    },
    {
        name: "王绍金",
        text: "西北农林科技大学，中国杨凌",
    },
    {
        name: "吴中华",
        text: "天津科技大学，中国天津",
    },
    {
        name: "肖红伟",
        text: "中国农业大学，中国北京",
    },
    {
        name: "郁东兴",
        text: "尚好科技有限公司，中国青岛",
    },
    {
        name: "查国才",
        text: "常州一步干燥设备有限公司，中国常州",
    },
    {
        name: "周存山",
        text: "江苏大学，中国镇江",
    },
        // {
        //     name: "王维",
        //     text: "大连理工大学，中国大连",
        // },

    ],
    committeetableData: [{
        date: "1",
        name: "Mujumdar A.S. (加拿大)",
        address: "Devahastin S. (泰国)",
    },
    {
        date: "2",
        name: "Abdelghani, B. (阿尔及利亚)",
        address: "Abdenouri, N. (摩洛哥)",
    },
    {
        date: "3",
        name: "Akinola A. (尼日利亚)",
        address: "Alves-Filho O. (挪威)",
    },
    {
        date: "4",
        name: "Andrieu J. (法国)",
        address: "Barresi A. (意大利)",
    },

    {
        date: "5",
        name: "Bruttini R. (意大利)",
        address: "Bhandari B. (澳大利亚)",
    },
    {
        date: "6",
        name: "Chen G. (中国香港)",
        address: "Chen X. D. (中国)",
    },
    {
        date: "7",
        name: "Farkas I. (匈牙利)",
        address: "Emam-Djomeh Z. (伊朗)",
    },

    {
        date: "8",
        name: "Itaya Y. (日本)",
        address: "Fortes M. (巴西)",
    },
    {
        date: "9",
        name: "Kemp I. (英国)",
        address: "Kechaou N. (突尼斯)",
    },
    {
        date: "10",
        name: "Krokida M. (希腊)",
        address: "Kowalski S. (波兰)",
    },

    {
        date: "11",
        name: "Langrish T. (澳大利亚)",
        address: "Kudra T. (加拿大)",
    },
    {
        date: "12",
        name: "Leonard A. (比利时)",
        address: "Law C.L. (马来西亚)",
    },
    {
        date: "13",
        name: "Miao S. (爱尔兰)",
        address: "Levy A. (以色列)",
    },

    {
        date: "14",
        name: "Opara L. (南非)",
        address: "Mulet A. (西班牙)",
    },
    {
        date: "15",
        name: "Pang S. (新西兰)",
        address: "Pakowski Z. (波兰)",
    },
    {
        date: "16",
        name: "Perré P. (法国)",
        address: "Peczalski R. (法国)",
    },
    {
        date: "17",
        name: "Rodriguez-Ramirez (墨西哥)",
        address: "Raghavan V. (加拿)",
    },
    {
        date: "18",
        name: "Rosello C. (西班牙)",
        address: "Renstrom R. (瑞典)",
    },

    {
        date: "19",
        name: "Prachayawarakorn S. (泰国) ",
        address: "Sarkar Md. S.H. (孟加拉国)",
    },
    {
        date: "20",
        name: "Sihem, B. (突尼斯)",
        address: "Schutyser M. (荷兰)",
    },

    {
        date: "21",
        name: "Thorat B. (印度)",
        address: "Taranto O. (巴西)",
    },
    {
        date: "22",
        name: "Tsotsas E. (德国)",
        address: "Timofeev O. (芬兰)",
    },
    {
        date: "23",
        name: "Zbicinski I. (波兰)",
        address: "Yagoobi J. (美国)",
    },
    {
        date: "24",
        name: "Zhou W. (新加坡)",
        address: "Zhang, M. (中国)",
    },
    ],

    //session
    sessionbigtitle: '主题报告',
    sessiontitle: '已确认的主题报告嘉宾:',
    sessionText18: [{
        num: "002",
        title: "Arun S. Mujumdar 教授",
        text: "麦吉尔大学",
        tip: "加拿大",
    },
    {
        num: "001",
        title: "Alex Martynenko 教授",
        text: "达尔豪斯大学",
        tip: "加拿大",
    },
    {
        num: "018",
        title: "Azharul Karim 教授",
        text: "昆士兰科技大学",
        tip: "澳大利亚",
    },
    {
        num: "007",
        title: "Benu Adhikari 教授",
        text: "皇家墨尔本理工大学",
        tip: "澳大利亚",
    },
    {
        num: "003",
        title: "Bhesh Bhandari 教授",
        text: "昆士兰大学",
        tip: "澳大利亚",
    },
    {
        num: "006",
        title: "Chung Lim Law 教授",
        text: "马来西亚诺丁汉大学",
        tip: "马来西亚",
    },
    {
        num: "026",
        title: "Dongxing Yu 高工/总经理",
        text: "尚好科技有限公司",
        tip: "中国",
    },
    {
        num: "012",
        title: "Duu-Jong Lee 教授",
        text: "香港城市大学",
        tip: "中国",
    },
    {
        num: "009",
        title: "Evangelos Tsotsas 教授",
        text: "马格德堡大学",
        tip: "德国",
    },
    {
        num: "022",
        title: "Gennadiy Semenov 教授",
        text: "俄罗斯生物技术大学",
        tip: "俄罗斯",
    },
    {
        num: "011",
        title: "Hongwei Xiao 教授",
        text: "中国农业大学",
        tip: "中国",
    },
    {
        num: "013",
        title: "Ireneusz Zbiciński 教授",
        text: "罗兹理工大学",
        tip: "波兰",
    },
    {
        num: "015",
        title: "Itaya Yoshinori 教授",
        text: "岐阜大学",
        tip: "日本",
    }, {
        num: "021",
        title: "Jamal Yagoobi 教授",
        text: "伍斯特理工学院",
        tip: "美国",
    },
    {
        num: "027",
        title: "Jing Wu 博士/高工/董事长",
        text: "山东天力能源股份有限公司",
        tip: "中国",
    },
    {
        num: "014",
        title: "Patrick Perre 教授",
        text: "巴黎萨克雷大学",
        tip: "法国",
    },
    {
        num: "016",
        title: "Peng Xu 教授",
        text: "中国计量大学",
        tip: "中国",
    },
    {
        num: "004",
        title: "Sakamon Devahastin 教授",
        text: "国王科技大学",
        tip: "泰国",
    },
    {
        num: "023",
        title: "Shaojin Wang 教授",
        text: "西北农林科技大学",
        tip: "中国",
    },
    {
        num: "008",
        title: "Shusheng Pang 教授",
        text: "坎特伯雷大学",
        tip: "新西兰",
    },
    {
        num: "010",
        title: "Song Miao 教授",
        text: "Teagasc国家食品研究中心",
        tip: "爱尔兰",
    },
    {
        num: "019",
        title: "Vijaya Raghavan 教授",
        text: "麦吉尔大学",
        tip: "加拿大",
    },
    {
        num: "005",
        title: "Xiao Dong Chen 教授",
        text: "苏州大学",
        tip: "中国",
    },
    {
        num: "020",
        title: "Xu Duan 教授",
        text: "河南科技大学",
        tip: "中国",
    }, {
        num: '025',
        title: "Zhongli Pan 教授",
        text: "加利福尼亚大学戴维斯分校",
        tip: "美国"
    }
    ],

    //program
    programbigtitle: '议程',
    programbigtext: 'MAIQS 2026 大会议程正在建设中。',

    //submissions
    submissionsbigtitle: '提交稿件',
    submissionstitle1: '报告主题领域',
    submissionstitle2: '作者说明',
    submissionstitle3: '重要日期',
    submissionstitle4: '投稿方式',
    submissdataList: [
        "干燥机理、建模和模拟",
        "物理特性和产品质量",
        "工业流程和设备",
        "测量和过程控制",
        "能源和环境问题",
        "渗透脱水和干燥",
        "气体和液体的干燥",
        "粉末固体的干燥",
        "生物质能源应用中的干燥",
        "食品和农业材料的干燥",
        "生物和制药材料的干燥",
        "化学品和聚合物的干燥",
        "木材、纸浆/纸张、林产品的干燥",
        "新型干燥技术及研发",
    ],

    submissionstext21: '1. 投稿英文摘要字数不超过150字。',
    submissionstext22: '2. 提交的全文稿件全文最少5页，最多8页。',
    submissionstext23: '3. 作品必须是原创的、未发表过、没有在任何其他会议或期刊上进行过评审。所 有投稿将由科学委员会根据其原创性、重要性、方法合理性和阐述清晰度进行同 行评审。',
    submissionstext30: '<b class="text-red">2024 年 2 月 15 日:</b> 摘要提交截止 <br />< b class= "text-red" > 2024 年 3 月 31 日: 摘要录用通知 < br /><b class="text-red">2024 年 4 月 30 日:</b> 稿件提交截止 < br /> <b class="text-red">2024 年 6 月 15 日:</b> 稿件录用通知',

    submissionstext31a: '2024 年 3 月 15 日:',
    submissionstext32a: '2024 年 3 月 31 日:',
    submissionstext33a: '2024 年 4 月 30 日:',
    submissionstext34a: '2024 年 6 月 15 日:',

    submissionstext31b: '摘要提交截止',
    submissionstext32b: '摘要录用通知',
    submissionstext33b: '稿件提交截止',
    submissionstext34b: '稿件录用通知',

    submissionstext41: '做“演讲+海报”或“只出海报”，则应按照以下摘要模板准备:',
    submissionstext42: '“全文稿件”应按照以下模板准备:',
    submissionstext43: '在线提交链接',
    submissionstext44: '网上投稿系统',


    //reg
    regbigtitle: '注册',
    regtitle1: '注册和付款',
    regtitle2: '退款政策:',

    regtext11: '1. 请填写信息并完成付款',
    regtext11a: '在线注册和付款信息',
    regtext11b: '请注意：上传的“付款凭证截图”将在十天内由会议秘书进行核实（跨境支付有较长的延迟）。',
    regtext12: '2. 请将付款订单 ID 和“付款email地址”通过电子邮件发送给',
    regtext12a: '并等待大会秘书处的确认。',
    regCategory: '类别',
    regtableData: [{
        one: "代表",
        two: "450 美元",
        three: "500 美元",
    },
    {
        one: "学生",
        two: "220 美元",
        three: "250 美元",
    },
    {
        one: "陪同人员",
        two: "150 美元",
        three: "150 美元",
    },
    ],

    regpayabout1: '2024年7月1日前"早鸟价"报名 【含宴会及文化活动费】 ',
    regpayabout2: '2024年7月1日后"正常全价"报名 【不含宴会&文化活动费】',


    regtext21a: '江南大学银行账户1(美元汇款):',
    regtext22a: '收款人全称: 江南大学',
    regtext23a: '收款银行: 中国银行无锡分行营业部',
    regtext24a: '银行账号: 474158228044',
    regtext25a: 'SWIFT CODE: BKCHCNBJ95C',
    regtext26a: '* 宴会和文化活动费: 50美元。',

    regtext21b: '江南大学银行账户2(人民币汇款)',
    regtext22b: '账户名称:江南大学(江南大学)',
    regtext23b: '开户行:工商银行无锡江南大学支行',
    regtext24b: '银行账号:1103030709100000136',

    regtext31: '2024 年9月1日之前取消的注册将退还80%的费用。2024年9月1日之后取消的注册将不予退款。',
    regtext32: '取消和退款申请必须通过电子邮件正式提出。缺席者将不予退款。组委会对无法控制的问题概不负责，如天气状况、校园状况、旅行困难、签证问题等。',
    regtext33: '* 组委会保留因不可抗力而更改会议日期和地点的权利。',
    regtext34: '* 因不可抗力事件造成的损失不承担责任，退款政策也不适用。',

    //awards
    awardstitle: 'MAIQS 2026 奖项',
    awardstitle1: '1. Arun S Mujumdar 奖章',
    awardstitle2: '2. MAIQS 2026主席奖',
    awardstitle3: '3. 青年干燥科学家奖',
    awardstitle4: '4. 优秀口头报告奖',
    awardstitle5: '5. 优秀海报展示奖',


    //sponsors
    sponsorsbigtitle: '赞助商',
    sponsorstext: '此页面正在建设中。',
    loginThenbigtitle23: 'MAIQS 2026会议论文集',
    loginThenbigtitle231: '（已注册参会者专享）',
    loginThenbigtitle24: '1、MAIQS 2026会议摘要集',
    loginThenbigtitle25: "2、MAIQS 2026会议论文集",

    //visa
    visabigtitle: '签证',
    visabigtitle1: '签证信息:',
    visatext1: '签证邀请函可根据要求提供。为了使请求得到尊重，您必须是已被录用摘要的作者或合著者。 请下载此',
    visatext2: '邀请函模板，',
    visatext3: '填写您的信息并在“我的会议信息管理”中进行',
    visatext4: '上传。',
    visatext5: '它在“我的会议仪表板”中。',
    visatext6: '签字盖章后会通过电子邮件发给您。',
    visatext7: '* 有关邀请函的重要信息（请阅读）：',
    visatext8: '请注意，IDS2024大会和大会组委会除了提供由IDS2024大会和大会委员会理事会签发的邀请函通知外，无权协助办理签证手续。如果您的申请被拒，IDS2024大会和大会组委会不能改变外交部的决定，IDS2024大会和大会组委会也不会代表申请人与外交部或大使馆进行讨论或通信。',
    visatext9: '使馆处理 VISA 申请需要一定时间，请尽早报名以确保您有足够的时间。',


    //travel
    travelbigtitle: '会场',
    traveltext1: 'MAIQS 2026将在无锡君来世尊酒店举行。',
    traveltext2: '无锡君来世尊酒店地址 :',
    traveltext3: '江苏省无锡市滨湖区太湖新城和风路111号',
    traveltext4: '酒店网站:',
    travelText5: 'https://j.map.baidu.com/7c/mW2K',
    travelText6: "zh",

    //traveltwo
    traveltwobigtitle: '旅行',
    traveltwotext: '此页面正在建设中。',

    //hotel
    hotelbigtitle: '酒店',
    hoteltext: '此页面正在建设中。',


    //submissionUpload
    submissionUploadtitle: '会议信息',
    submissionUploadtext1: '第23届国际干燥研讨会(MAIQS 2026)',
    submissionUploadtext2: '会议日期:',
    submissionUploadtext3: '2024年11月22-25日',
    submissionUploadtext4: '会场',
    submissionUploadtext5: '无锡君来世尊酒店，中国无锡',

    submissionUploadmessageTitle: "请输入标题",
    submissionUploadmessageAbstract: "请输入摘要",
    submissionUploadmessagekeyword: "请输入关键字",
    submissionUploadmessagefile: "请选择上传文件",
    submissionUploadmessageauthor: "请输入作者",

    submissionUploadmessageauthor1: "请输入作者",
    submissionUploadmessageauthor1Firstname: "的名字(英文)",
    submissionUploadmessageauthor1Lastname: "的中间名:",
    submissionUploadmessageauthor1Position: "的职位",
    submissionUploadmessageauthor1Affiliation: "的机构(英文)",
    submissionUploadmessageauthor1email: "的电子邮箱",


    submissionUploadtitle: '论文信息',

    submissionUploadtext21: '作者信息',
    submissionUploadtext22: '电子邮件地址将仅用于与作者沟通，“通讯作者”将收到来自系统的邮件。关于投稿，应至少标记一位通讯作者 。',
    submissionUploadAuthor: '作者',
    submissionUploadAuthortext: '(请至少填写一位作者信息)',
    submissionUploadtext23: '单击此处添加更多作者',

    submissionUploadmoreauthors: '单击此处添加更多作者',
    submissionUploadtext24: '删除',
    submissionUploadtext25: '提交成功!',
    submissionUploadtext26: "文件不能超过200M",

    submissionUploadtext30: '名字(英文):*',
    submissionUploadtext31: '中间名:',
    submissionUploadtext32: '姓氏(英文):*',
    submissionUploadtext33: '职位:',
    submissionUploadtext34: '机构(英文):*',
    submissionUploadtext35: '电子邮件:*',
    submissionUploadtext36: '通讯作者:',
    submissionUploadtext37: '口头报告作者:',
    submissionUploadtext38: '职位',
    submissionUploadtext39: '',
    submissionUploadtext40: '',

    submissionUploadSubmissionType: '投稿类型:*',
    submissionUploadAbstract: '摘要 (口头报告和海报)',
    submissionUploadPosterOnly: '摘要 (只海报)',
    submissionUploadFullpaper: '现在“全文稿件”提交尚未开放。当您在2024年3月31日收到摘要录用通知时，您可以选择开始提交全文。',
    submissionUploadtitleandAbstract: '标题和摘要',
    submissionUploadTitle: '标题:',
    submissionUploadTitleAbstract: '摘要:',
    submissionUploadAbstractabout: '标题和摘要应以纯文本形式输入，不应包含HTML元素。',
    submissionUploadKeywords: '关键词:',
    submissionUploadKeywordsabout: '至少指定三个关键词，以逗号分隔。',
    submissionUploadselect: '选择文件:',
    submissionUploadabouts: '如果您已填写表格，请点击下方“提交” 按钮。上传可能需要一段时间，请不要点击按钮两次。',

    submissionUploadSubmission: '提交',
    submissionUploadPeopleList: [
        [{
            text: "名字(英文):*",
            value: "",
            radio: "a",
        },
        {
            text: "中间名:",
            value: "",
            radio: "a",
        },
        {
            text: "姓氏(英文):*",
            value: "",
            radio: "a",
        },
        {
            text: "职位:",
            value: "",
            radio: "c",
            list: [{
                text: "Position",
            },
            {
                text: "Prof.",
            },
            {
                text: "Associate Prof.",
            },
            {
                text: "Assiatant Prof.",
            },
            {
                text: "Dr.",
            },
            {
                text: "Master",
            },
            {
                text: "Seniot Lecturer",
            },
            {
                text: "Lecturer",
            },
            {
                text: "Ph.D student",
            },
            {
                text: "Master student",
            },
            {
                text: "Undergraduate student",
            },
            {
                text: "Others",
            },
            ],
        },
        {
            text: "机构(英文):*",
            value: "",
            radio: "a",
        },
        {
            text: "电子邮件:*",
            value: "",
            radio: "a",
        },
        {
            text: "通讯作者:",
            value: "1",
            radio: "b",
        },
        {
            text: "口头报告作者:",
            value: "1",
            radio: "d",
        },
        ],
    ],
    submissionUploadItem: [{
        text: "名字(英文):*",
        value: "",
        radio: "a",
    },
    {
        text: "中间名:",
        value: "",
        radio: "a",
    },
    {
        text: "姓氏(英文):*",
        value: "",
        radio: "a",
    },
    {
        text: "职位:*",
        value: "",
        radio: "c",
        list: [{
            text: "Position",
        },
        {
            text: "Prof.",
        },
        {
            text: "Associate Prof.",
        },
        {
            text: "Assiatant Prof.",
        },
        {
            text: "Dr.",
        },
        {
            text: "Master",
        },
        {
            text: "Seniot Lecturer",
        },
        {
            text: "Lecturer",
        },
        {
            text: "Ph.D student",
        },
        {
            text: "Master student",
        },
        {
            text: "Undergraduate student",
        },
        {
            text: "Others",
        },
        ],
    },
    {
        text: "机构(英文):*",
        value: "",
        radio: "a",
    },
    {
        text: "电子邮件:*",
        value: "",
        radio: "a",
    },
    {
        text: "通讯作者:",
        value: "1",
        radio: "b",
    },
    {
        text: "口头报告作者:",
        value: "1",
        radio: "d",
    },
    ],


    //loginThen
    loginThenbigtitle: '签证',
    loginThentext1: '签证邀请函可根据要求提供。为了使请求得到尊重，您必须是已被录用摘要的作者或合著者。 请下载此',

    //loginThen
    loginThenbigtitle: '我的会议信息管理',
    loginThentitle1: '在线提交系统',
    loginThentitle12: '(摘要/论文全文)',
    loginThentitle2: '注册',
    loginThentitle3: '付费',
    loginThentitle4: '邀请函',
    loginThentextabout: '演讲者需要上传一篇“摘要/全文”',
    loginThenUpload: '上传',

    loginThenPaperID: '文章 ID',
    loginThentitle: '题目',
    loginThensubmissionType: '提交类型',
    loginThenkeywords: '关键词',
    loginThensuEdit: '编辑',
    loginThenDelete: '删除',

    //simpleReg
    simpleRegTitle: '头衔',
    simpleRegFirstname: '名字(英文)',
    simpleRegLastname: '姓氏(英文)',
    simplePassword: '密码',
    simplePasswordpic: '密码长度需要为6-15',
    simpleRetypePassword: '重新键入密码',
    simpleCode: '验证码*（区分大小写）',
    simpleSignin: '注册',
    simpleSignintip1: '已注册？',
    simpleSignintip2: '到登录页',


    simpleSignmsgemail: '请输入您的电子邮件地址',
    simpleSignmsgFirstname: '请输入您的名字(英文)',
    simpleSignmsgLastname: '请输入您的姓氏(英文)',
    simpleSignmsgPassword: '请输入您的密码',

    simpleSignmsgRetypePassword: '请重新输入您的密码',
    simpleSignmsgPasswordinconsistency: '两次密码不一致',

    simpleSignmsgpasswordpic: '密码长度需要为6-15',
    simpleSignmsgCode: '请输入验证码',
    simpleSignmsgCodeinconsistency: '验证代码不一致',
    simpleSignmsgRegistrationsuccessful: '注册成功',

    newsDetailText1: "摘要提交截止日期延长至 3 月 15 日",
    newsDetailText2: "[通知] 论文摘要提交截止日期延长至 3 月 15 日。",
    newsDetailText3: "我们希望能让更多的人有机会积极参与大会，分享他们的最新研究成果，从而使大会的内容更加丰富和有趣.",
    newsDetailText4: "期待您的论文摘要，期待您参与 IDS2024！",
    newsDetailText5: '距离摘要提交截止仅剩1周',
    newsDetailText6: "——2024年3月8日更新",
    newsDetailText7: 'zh',
    newsDetailText8: '距离全文提交截止仅剩1周',
    newsDetailText9: "——2024年4月23日更新",
    newsDetailText10: '注册与付款，酒店预订，签证邀请函，正在如火如荼地进行中!',

    newsDetailText10up: "——更新于2024年7月9日",
    newsDetailimgurl: "1720534045615.jpg",

    newsDetailTexttitle11: "* 1. ",
    newsDetailText11: "请通过",
    newsDetailText12: "在线注册系统",

    newsDetailText13: "填写您和同行人员参加IDS2024的注册信息，并上传付款凭证截图。会议秘书将核验您的注册和付款信息。",
    newsDetailTexttitle12: "* 2. ",
    newsDetailText14: "酒店预订正在进行中。请提前通过我们的IDS2024网站预订酒店房间，点击",
    newsDetailText15: "此处",

    newsDetailText16: "预订，您可以在抵达当天现场付款。我们强烈建议尽快预订酒店房间!",
    newsDetailTexttitle13: "* 3. ",
    newsDetailText17: "如果您需要签证邀请函，请点击",
    newsDetailText18: "了解申请流程。",

    newsDetailTexttitle14: " * 4. ",
    newsDetailText19: '您可以在IDS2024网站的“参会者须知”菜单中找到有关“签证、会场、旅行和酒店”的信息。',

    newsDetailTexttitle15: " * Tips：",
    newsDetailText20: "我们强烈建议您在在线注册系统中填写您的注册信息，这将使支付和核验过程非常顺利。即使您已经付款，也请补充完成在线注册流程。非常感谢！",
    newsDetailText21: "注册截止日期延期至10月1日",
    newsDetailText22: "——更新于2024年9月9日",
    newsDetailText23: "【通知】注册截止日期延长至10月1日。",
    newsDetailText24: "有关注册及付款、酒店预订、VISA邀请函等信息，请点击",
    newsDetailText25: "此处",
    newsDetailText26: "*提示: 强烈建议您尽早完成您的注册，酒店预订和签证邀请函，因为这将减少不必要的烦恼",
    newsDetailText27: "排名不分先后，建设中",
    newsDetailText28: "赞助商名单",
    newsDetailText29: "第二十三届国际干燥大会",
    newsDetailText30: "暂定议程",
    newsDetailText31: "如果您无法在线浏览此 PDF 文件，则可以下载此",
    newsDetailText32: "PDF文件",
    newsDetailText33: "新发布的暂定会议议程!",
    newsDetailText34: "",
    newsDetailText35: "",
    newsDetailText36: "",
    newsDetailText37: "",
    newsDetailText38: "",
    newsDetailText39: "",
    newsDetailText40: "",
}


// WEBPACK FOOTER //
// ./src/utils/zh.js